import React, { useState, useEffect } from 'react';
import './styles.css';

const MobileBlogs = ({ isDarkMode }) => {
    const [blogsData, setBlogsData] = useState([]);
    const [selectedBlog, setSelectedBlog] = useState(null);

    useEffect(() => {
        fetch('/data/blogs.json')
            .then(response => response.json())
            .then(data => {
                const sortedBlogs = [...data].sort((a, b) => b.id - a.id);
                setBlogsData(sortedBlogs);
            })
            .catch(error => console.error('Error fetching blogs data:', error));
    }, []);

    const openModal = (blog) => {
        setSelectedBlog(blog);
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setSelectedBlog(null);
        document.body.style.overflow = 'auto';
    };

    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                closeModal();
            }
        };

        if (selectedBlog) {
            document.addEventListener('keydown', handleEscape);
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [selectedBlog]);

    return (
        <div className="mobile-page">
            <div className="mobile-content-wrapper">
                <div className="mobile-page-header">
                    <h1 className="mobile-page-header-title">Blog</h1>
                    <div className="mobile-page-header-accent"></div>
                </div>

                <div className="mobile-content-section">
                    {blogsData.length > 0 ? (
                        blogsData.map((blog, index) => (
                            <div key={index} className="mobile-card mobile-blog-card" onClick={() => openModal(blog)}>
                                {blog.image && (
                                    <div className="mobile-blog-image-container">
                                        <img src={blog.image} alt={blog.title} className="mobile-blog-image" />
                                    </div>
                                )}
                                <div className="mobile-blog-meta">
                                    <span className="mobile-card-period">{blog.date}</span>
                                    {blog.category && (
                                        <span className="mobile-blog-category">{blog.category}</span>
                                    )}
                                </div>
                                <h3 className="mobile-card-title">{blog.title}</h3>
                                <p className="mobile-card-description">{blog.summary || blog.excerpt || blog.description}</p>
                                {blog.tags && blog.tags.length > 0 && (
                                    <div className="mobile-tech-list">
                                        {blog.tags.map((tag, tagIndex) => (
                                            <span key={tagIndex} className="mobile-tech-item">{tag}</span>
                                        ))}
                                    </div>
                                )}
                                <div className="mobile-blog-read-more">
                                    Read Full Article →
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="mobile-card">
                            <p className="mobile-card-description">Blog posts coming soon...</p>
                        </div>
                    )}
                </div>
            </div>

            {selectedBlog && (
                <div className="mobile-blog-modal-overlay" onClick={closeModal}>
                    <div className="mobile-blog-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="mobile-blog-modal-close" onClick={closeModal}>&times;</button>
                        <div className="mobile-blog-modal-header">
                            <h2 className="mobile-blog-modal-title">{selectedBlog.title}</h2>
                            <span className="mobile-blog-modal-date">{selectedBlog.date}</span>
                        </div>
                        <div className="mobile-blog-modal-body">
                            <p className="mobile-blog-modal-text">
                                {selectedBlog.content}
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MobileBlogs;
